import OwnableTheme from '@Theme';
import Svg, { Path } from 'react-native-svg';

type Props = {
  width?: number;
  color?: string;
};

export const MiniMapPointerArrow = ({
  width = 103,
  color = OwnableTheme.colors.amaranth,
}: Props) => {
  const height = (94 / 103) * width; // based on viewBox size

  return (
    <Svg width={width} height={height} viewBox='0 0 103 94' fill='none'>
      <Path
        d='M11.9999 80.9229C18.6419 54.3132 48 12.6097 102.229 12.6097'
        stroke={color}
        strokeWidth='4'
        strokeMiterlimit='2.9987'
      />
      <Path
        d='M10.488 84.9694L7.25864 67.6736L23.8519 73.5249L10.488 84.9694Z'
        fill={color}
      />
    </Svg>
  );
};
